import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faAngleLeft,
    faAngleRight,
    faArrowLeft,
    faArrowRight,
    faEdit,
    faMinusCircle,
    faPlusCircle,
    faQuestionCircle,
    faRedo,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import Colours from '../State/Colours';

library.add(faEdit);
library.add(faMinusCircle);
library.add(faPlusCircle);
library.add(faArrowLeft);
library.add(faArrowRight);
library.add(faQuestionCircle);
library.add(faRedo);
library.add(faAngleLeft);
library.add(faAngleRight);

export const ArrowLeft = (props: any) => <FontAwesomeIcon icon="arrow-left" color={Colours.primary} {...props}/>;
export const ArrowRight = (props: any) => <FontAwesomeIcon icon="arrow-right" color={Colours.primary} {...props}/>;
export const MinusCircle = (props: any) => <FontAwesomeIcon icon="minus-circle" color={Colours.gray} {...props}/>;
export const PlusCircle = (props: any) => <FontAwesomeIcon icon="plus-circle" color={Colours.primary} {...props}/>;
export const EditIcon = (props: any) => <FontAwesomeIcon icon="edit" color={Colours.gray} style={{ cursor: 'pointer' }} {...props}/>;
export const QuestionMark = (props: any) => <FontAwesomeIcon {...props} icon="question-circle" />;
export const Reload = (props: any) => <FontAwesomeIcon icon="redo" {...props}/>;
export const AngleLeft = (props: any) => <FontAwesomeIcon icon="angle-left" {...props}/>;
export const AngleRight = (props: any) => <FontAwesomeIcon icon="angle-right" {...props}/>;



// WEBPACK FOOTER //
// ./src/Components/Icons.tsx